module.exports = __webpack_public_path__ + "static/media/promo-image-coins.304a6c05.png";